import MetaModel from "../../../Global/Models/Pagination/MetaModel";
import EventGameModel from "./EventGameModel";

export default class EventGamesModel {
  public meta: MetaModel = new MetaModel();
  public data: EventGameModel[] = [];
}
